import React, { Component } from 'react';
import {Link} from 'react-router-dom'

class Intro extends Component {
    render() {
        return (
          <section className="pt-50 center-about bg-grey">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="section-heading text-center">
                    <h2>Storyteller Group</h2>
                    <p>
                      This website is a prototype for a children’s picture book,
                      created as part of the EDF5776 assessment in the Master of
                      Education program at Monash University,
                      showcasing a collaborative digital story designed to spark
                      social justice dialogue.{""}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
    }
}

export default Intro;
